<div class="health-container">
  <div class="main-container">
    <div class="main-content">
      <!-- <div class="list-header" *ngIf="insuranceList.length === 0 || allergyList.length == 0 || immunizationList.length == 0 || medconList.length == 0 || famHistoryList.length == 0">
        <button class="back-btn" (click)="goBack()">
          <i class="fas fa-chevron-left"></i>
        </button>
        <h2>{{getLogTitle(selected)}}</h2>
      </div> -->

      <div class="document-list">
        <!-- List title + Search + Add button -->
        <div class="list-toolbar" *ngIf="(allergyList?.length || 
        insuranceList?.length || 
        immunizationList.length ||
        medconList.length || 
        famHistoryList.length ) > 0">
        <button class="back-btn" (click)="goBack()">
          <i class="fas fa-chevron-left"></i>
        </button>
          <h2 class="listMed" *ngIf="insuranceList.length> 0">List Of Insurances ( {{ (insuranceList | filterAll:searchText)?.length || 0 }} )</h2>
          <h2 class="listMed" *ngIf="allergyList.length> 0">List Of Allergy ( {{ (allergyList | filterAll:searchText)?.length || 0 }} )</h2>
          <h2 class="listMed" *ngIf="immunizationList.length> 0">List Of Immunizations ( {{ (immunizationList | filterAll:searchText)?.length || 0 }} )</h2>
          <h2 class="listMed" *ngIf="medconList.length> 0">List Of Medical Conditions ( {{ (medconList | filterAll:searchText)?.length || 0 }} )</h2>
          <h2 class="listMed" *ngIf="famHistoryList.length> 0">List Of Family History ( {{ (famHistoryList | filterAll:searchText)?.length || 0 }} )</h2>
          <div class="toolbar-actions">
            <div class="search-section">
              <div class="search-container">
                <input class="search-text" type="text" [(ngModel)]="searchText" #filter placeholder="Search For {{headerTitle}}..." [attr.aria-label]="'Search ' + headerTitle">
                <i class="material-icons" aria-hidden="true">search</i>
              </div>
            </div>
            <button type="button" class="add-record-btn" (click)="openDialog()" [attr.aria-label]="'Add ' + getBtnTitle(selected)">
              <i class="material-icons" aria-hidden="true">add</i>
              <span>Add {{ getBtnTitle(selected) }}</span>
            </button>
          </div>
        </div>

        <!-- Only show one list at a time -->
        <ng-container [ngSwitch]="true">
          <!-- Allergy List -->
          <ng-container *ngSwitchCase="allergyList.length > 0">
            <div class="medication-grid">
              <div class="medication-card" *ngFor="let med of allergyList | filterAll:searchText">
                <div class="card-header">
                  <div class="med-icon dash-tile" aria-hidden="true"><svg class="dash-ico" viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="3"/><line x1="12" y1="9" x2="12" y2="4"/><circle cx="12" cy="3.5" r="1.2"/><line x1="14.6" y1="10.4" x2="18.6" y2="7.2"/><circle cx="19.3" cy="6.7" r="1.2"/><line x1="14.6" y1="13.6" x2="18.6" y2="16.8"/><circle cx="19.3" cy="17.3" r="1.2"/><line x1="12" y1="15" x2="12" y2="20"/><circle cx="12" cy="20.5" r="1.2"/><line x1="9.4" y1="13.6" x2="5.4" y2="16.8"/><circle cx="4.7" cy="17.3" r="1.2"/><line x1="9.4" y1="10.4" x2="5.4" y2="7.2"/><circle cx="4.7" cy="6.7" r="1.2"/></svg></div>
                  <div class="med-title-group">
                    <h3 class="med-name">{{ med.allergicTo | titlecase  }}</h3>
                    <p class="med-info">{{ med.allergicReaction.join(', ') }}</p>
                  </div>
                  <div class="card-actions">
                    <button mat-icon-button [matMenuTriggerFor]="menuAllergy">
                      <mat-icon>more_vert</mat-icon>
                    </button>
                    <mat-menu #menuAllergy="matMenu">
                      <button mat-menu-item (click)="onView(med)">
                        <mat-icon class="menu-view-icon" aria-hidden="true">visibility</mat-icon>&nbsp;
                        <span>View Details</span>
                      </button>
                      <button mat-menu-item (click)="onEdit(med)">
                        <img class="imgbtn" src="assets/images/health/icons/iconamoon_edit-light.svg" />&nbsp;
                        <span>Edit</span>
                      </button>
                      <button mat-menu-item (click)="onDelete(med)">
                        <img class="imgbtn" src="assets/images/health/icons/fluent_delete-28-regular.svg" />&nbsp;
                        <span>Delete</span>
                      </button>
                    </mat-menu>
                  </div>
                </div>

                <div class="card-footer">
                  <div class="severity">
                    <span class="severity-indicator"
                          [ngClass]="{
                            'high': med.severity?.toLowerCase() === 'high',
                            'medium': med.severity?.toLowerCase() === 'medium',
                            'low': med.severity?.toLowerCase() === 'low'
                          }">
                    </span>
                    <span class="severity-label">{{ med.severity | titlecase }}</span>
                  </div>
                </div>
              </div>
            </div>
          </ng-container>

          <!-- Insurance List -->
          <ng-container *ngSwitchCase="insuranceList.length > 0">
            <div class="medication-grid">
              <div class="medication-card" *ngFor="let med of insuranceList | filterAll:searchText">
                <div class="card-header">
                  <div class="med-icon dash-tile" aria-hidden="true"><svg aria-hidden="true" class="dash-ico dash-ico--ins" viewBox="0 0 24 24"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg></div>
                  <div class="med-title-group">
                    <h3 class="med-name">{{ med.insuranceCompany | titlecase }}</h3>
                  </div>
                  <div class="card-actions">
                    <button mat-icon-button [matMenuTriggerFor]="menuInsurance">
                      <mat-icon>more_vert</mat-icon>
                    </button>
                    <mat-menu #menuInsurance="matMenu">
                      <button mat-menu-item (click)="onView(med)">
                        <mat-icon class="menu-view-icon" aria-hidden="true">visibility</mat-icon>&nbsp;
                        <span>View Details</span>
                      </button>
                      <button mat-menu-item (click)="onEdit(med)">
                        <img class="imgbtn" src="assets/images/health/icons/iconamoon_edit-light.svg" />&nbsp;
                        <span>Edit</span>
                      </button>
                      <button mat-menu-item (click)="onDelete(med)">
                        <img class="imgbtn" src="assets/images/health/icons/fluent_delete-28-regular.svg" />&nbsp;
                        <span>Delete</span>
                      </button>
                    </mat-menu>
                  </div>
                </div>

                <div class="card-footer">
                  <div class="severity">
                    <span class="severity-indicator"
                          [ngClass]="{
                            'low': med.status?.toLowerCase() === 'active',
                            'medium': med.status?.toLowerCase() === 'inactive'
                          }">
                    </span>
                    <span class="severity-label">{{ med.status | titlecase }}</span>
                  </div>
                </div>
              </div>
            </div>
          </ng-container>

          <!-- Immunization List -->
          <ng-container *ngSwitchCase="immunizationList.length > 0">
            <div class="medication-grid">
              <div class="medication-card" *ngFor="let med of immunizationList | filterAll:searchText">
                <div class="card-header">
                  <div class="med-icon dash-tile" aria-hidden="true"><svg class="dash-ico" viewBox="0 0 24 24" aria-hidden="true"><path d="M18 2l4 4M17 7l3-3M19 9l-8.7 8.7a2 2 0 0 1-2.8 0L6.3 16.5a2 2 0 0 1 0-2.8L15 5M9 11l4 4M5 19l-3 3M14 4l6 6"/></svg></div>
                  <div class="med-title-group">
                    <h3 class="med-name">{{ med.vaccineName | titlecase }}</h3>
                    <p class="med-info">{{ med.adminDate }}</p>
                  </div>
                  <div class="card-actions">
                    <button mat-icon-button [matMenuTriggerFor]="menuImmunization">
                      <mat-icon>more_vert</mat-icon>
                    </button>
                    <mat-menu #menuImmunization="matMenu">
                      <button mat-menu-item (click)="onView(med)">
                        <mat-icon class="menu-view-icon" aria-hidden="true">visibility</mat-icon>&nbsp;
                        <span>View Details</span>
                      </button>
                      <button mat-menu-item (click)="onEdit(med)">
                        <img class="imgbtn" src="assets/images/health/icons/iconamoon_edit-light.svg" />&nbsp;
                        <span>Edit</span>
                      </button>
                      <button mat-menu-item (click)="onDelete(med)">
                        <img class="imgbtn" src="assets/images/health/icons/fluent_delete-28-regular.svg" />&nbsp;
                        <span>Delete</span>
                      </button>
                    </mat-menu>
                  </div>
                </div>

                <div class="card-footer" *ngIf="med.nextDueDate">
                  <div class="status-badge">
                    Next Due on {{ convertDateFormat(med.nextDueDate) }}
                  </div>
                </div>
              </div>
            </div>
          </ng-container>

          <!-- Family History -->
          <ng-container *ngSwitchCase="famHistoryList.length > 0">
            <div class="medication-grid">
              <div class="medication-card" *ngFor="let med of famHistoryList | filterAll:searchText">
                <div class="card-header">
                  <div class="med-icon dash-tile" aria-hidden="true"><svg class="dash-ico" viewBox="0 0 24 24" aria-hidden="true"><circle cx="9" cy="8" r="3.5"/><path d="M2 21a7 7 0 0 1 14 0M17 4.5a3.5 3.5 0 0 1 0 7M22 21a7 7 0 0 0-4-6.3"/></svg></div>
                  <div class="med-title-group">
                    <h3 class="med-name">{{ med.conditionName }}</h3>
                    <p class="med-info">{{ med.relationship.join(', ') | titlecase  }}</p>
                  </div>
                  <div class="card-actions">
                    <button mat-icon-button [matMenuTriggerFor]="menuFamHistory">
                      <mat-icon>more_vert</mat-icon>
                    </button>
                    <mat-menu #menuFamHistory="matMenu">
                      <button mat-menu-item (click)="onView(med)">
                        <mat-icon class="menu-view-icon" aria-hidden="true">visibility</mat-icon>&nbsp;
                        <span>View Details</span>
                      </button>
                      <button mat-menu-item (click)="onEdit(med)">
                        <img class="imgbtn" src="assets/images/health/icons/iconamoon_edit-light.svg" />&nbsp;
                        <span>Edit</span>
                      </button>
                      <button mat-menu-item (click)="onDelete(med)">
                        <img class="imgbtn" src="assets/images/health/icons/fluent_delete-28-regular.svg" />&nbsp;
                        <span>Delete</span>
                      </button>
                    </mat-menu>
                  </div>
                </div>
              </div>
            </div>
          </ng-container>

          <!-- Medical Conditions -->
          <ng-container *ngSwitchCase="medconList.length > 0">
            <div class="medication-grid">
              <div class="medication-card" *ngFor="let med of medconList | filterAll:searchText">
                <div class="card-header">
                  <div class="med-icon"><img class="imghel" src="assets/images/health/icons/med-condlt.png" /></div>
                  <div class="med-title-group">
                    <h3 class="med-name">{{ med.conditionName | titlecase }}</h3>
                    <p class="med-info">{{ med.yearOfDiagnosis }}</p>
                  </div>
                  <div class="card-actions">
                    <button mat-icon-button [matMenuTriggerFor]="menuMedCond">
                      <mat-icon>more_vert</mat-icon>
                    </button>
                    <mat-menu #menuMedCond="matMenu">
                      <button mat-menu-item (click)="onView(med)">
                        <mat-icon class="menu-view-icon" aria-hidden="true">visibility</mat-icon>&nbsp;
                        <span>View Details</span>
                      </button>
                      <button mat-menu-item (click)="onEdit(med)">
                        <img class="imgbtn" src="assets/images/health/icons/iconamoon_edit-light.svg" />&nbsp;
                        <span>Edit</span>
                      </button>
                      <button mat-menu-item (click)="onDelete(med)">
                        <img class="imgbtn" src="assets/images/health/icons/fluent_delete-28-regular.svg" />&nbsp;
                        <span>Delete</span>
                      </button>
                    </mat-menu>
                  </div>
                </div>
              </div>
            </div>
          </ng-container>

          <!-- Empty State -->
          <!-- <ng-container *ngSwitchDefault>
          <div class="empty-state">
            <img *ngIf="selected === 'allergy'" class="noimg" src="assets/images/health/icons/allergies 1(1).svg" />
            <img *ngIf="selected === 'insurance'" class="noimg" src="assets/images/health/icons/insurance ico1.svg" />
            <img *ngIf="selected === 'familyhistory'" class="noimg" src="assets/images/health/healthlogico/familyhispng.png" />
            <img *ngIf="selected === 'medicalcondition'" class="noimg" src="assets/images/health/healthlogico/medicalconpng.png" />
            <img *ngIf="selected === 'immunization'" class="noimg" src="assets/images/health/healthlogico/immunizpng.png" />

            <h3>Manage {{selected | titlecase}}</h3>
            <p>Keep track of your {{selected}}</p>
            <button class="add-new-btn" mat-raised-button (click)="openDialog()">
              <span class="btn-text"> Add {{selected | titlecase}}</span>
            </button>
          </div>
          </ng-container> -->

          <ng-container *ngSwitchDefault>
            <div class="empty-state-card">
              <!-- Log Img -->
              <ng-container *ngIf="selected" [ngSwitch]="selected">
                <span *ngSwitchCase="'insurance'" class="empty-tile" aria-hidden="true"><svg aria-hidden="true" class="dash-ico dash-ico--ins" viewBox="0 0 24 24"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg></span>
                <span *ngSwitchCase="'allergy'" class="empty-tile" aria-hidden="true"><svg class="dash-ico" viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="3"/><line x1="12" y1="9" x2="12" y2="4"/><circle cx="12" cy="3.5" r="1.2"/><line x1="14.6" y1="10.4" x2="18.6" y2="7.2"/><circle cx="19.3" cy="6.7" r="1.2"/><line x1="14.6" y1="13.6" x2="18.6" y2="16.8"/><circle cx="19.3" cy="17.3" r="1.2"/><line x1="12" y1="15" x2="12" y2="20"/><circle cx="12" cy="20.5" r="1.2"/><line x1="9.4" y1="13.6" x2="5.4" y2="16.8"/><circle cx="4.7" cy="17.3" r="1.2"/><line x1="9.4" y1="10.4" x2="5.4" y2="7.2"/><circle cx="4.7" cy="6.7" r="1.2"/></svg></span>
                <span *ngSwitchCase="'immunization'" class="empty-tile" aria-hidden="true"><svg class="dash-ico" viewBox="0 0 24 24" aria-hidden="true"><path d="M18 2l4 4M17 7l3-3M19 9l-8.7 8.7a2 2 0 0 1-2.8 0L6.3 16.5a2 2 0 0 1 0-2.8L15 5M9 11l4 4M5 19l-3 3M14 4l6 6"/></svg></span>
                <span *ngSwitchCase="'familyhistory'" class="empty-tile" aria-hidden="true"><svg class="dash-ico" viewBox="0 0 24 24" aria-hidden="true"><circle cx="9" cy="8" r="3.5"/><path d="M2 21a7 7 0 0 1 14 0M17 4.5a3.5 3.5 0 0 1 0 7M22 21a7 7 0 0 0-4-6.3"/></svg></span>
                <img *ngSwitchDefault class="empty-icon" [src]="logIcons[selected]" alt="Icon"/>
              </ng-container>

               <!-- Log Title -->
               <h3>Manage {{ getLogTitle(selected) }}</h3>

              <!-- Logs Div -->
              <!-- insurance -->
              <div class="empty-description" *ngIf="selected === 'insurance'">
                <div class="desc-item">
                  <img src="assets/images/health/homeimg/business chart with dollar.svg" alt="Track" />
                  <span class="trackTxt">Keep track of your {{selected}}</span>
                </div>
                <div class="desc-item">
                  <img src="assets/images/health/icons/data medis.svg" alt="Check" />
                  <span class="trackTxt">Check your coverage</span>
                </div>
              </div>
              <!-- familyhistory -->
              <div class="empty-description" *ngIf="selected === 'familyhistory' || selected === 'medicalcondition'">
                <div class="desc-item">
                  <img src="assets/images/health/homeimg/dna.svg" alt="Track" />
                  <span class="trackTxt">Track inherited health conditions</span>
                </div>
                <div class="desc-item">
                  <img src="assets/images/health/homeimg/family_16004600 1.svg" alt="Check" />
                  <span class="trackTxt">Stay informed for preventive care</span>
                </div>
              </div>
              
              <!-- allergy -->
              <div class="empty-description" *ngIf="selected === 'allergy'">
                <div class="desc-item">
                  <img src="assets/images/health/homeimg/suntik.svg" alt="Track" />
                  <span class="trackTxt">Keep track of your allergies</span>
                </div>
                <div class="desc-item">
                  <img src="assets/images/health/homeimg/masker.svg" alt="Check" />
                  <span class="trackTxt">Avoid allergic reactions</span>
                </div>
              </div>

              <!-- immunization -->
              <div class="empty-description" *ngIf="selected === 'immunization'">
                <div class="desc-item">
                  <img src="assets/images/health/homeimg/suntik.svg" alt="Track" />
                  <span class="trackTxt">Stay updated on your vaccines</span>
                </div>
                <div class="desc-item">
                  <img src="assets/images/health/homeimg/masker.svg" alt="Check" />
                  <span class="trackTxt">Check your coverage</span>
                </div>
              </div>
              <!-- Logs Div ends here -->

              <!-- Log Button -->
              <button class="add-new-btn" mat-raised-button (click)="openDialog()">
                Add {{ getBtnTitle(selected) }}
              </button>    
              <!-- Log Button -->

            </div>
          </ng-container>


        </ng-container>
      </div>
    </div>
  </div>
</div>